import axios from 'axios';
import { BASE_URL_ADDR } from '../Constants/BaseURL';

axios.defaults.baseURL = BASE_URL_ADDR;
axios.defaults.timeout = 120000;
// axios.defaults.baseURL = 'https://41.242.54.157:443';

axios.interceptors.request.use(function (config:any) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json';
  config.headers.common.Accept = 'application/json';
  config.headers.post['Access-Control-Allow-Origin'] = "*";
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

const fileService = {

  uploadImageAx: async (data:any) => {
    return await axios.post('/save-nin-status?module=portal&admissionId=4', data);
  },
  getCloudEndpoint: async (data:any) => {
    return await axios.post('/recruitment/request-upload-presigned-url?admissionId=4', data);
  },

  uploadManifesr: async (data:any) => {
    return await axios.post('/recruitment/tick-upload-manifest?admissionId=4', data);
  },

  askForManifest: async (data: {nin: string, workflow: string, profileFetchMode: number}) => {
    return await axios.post('/recruitment/request-for-document-manifest', data)
  }
}

export default fileService
